import React, { useMemo } from 'react';

import ConnectedEntityPickerModal from './ConnectedEntityPickerModal';
import PluginProvidersProvider from '../providers/PluginProvidersProvider';

const EntityPickerModal = (props) => {
  const pluginAsArray = useMemo(
    () => (props.plugin ? [props.plugin] : []),
    [props.plugin],
  );
  return (
    <PluginProvidersProvider plugins={pluginAsArray}>
      <ConnectedEntityPickerModal {...props} />
    </PluginProvidersProvider>
  );
};

EntityPickerModal.propTypes = ConnectedEntityPickerModal.propTypes;

export default EntityPickerModal;
